  function formatMoney(cents) { 
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  document.addEventListener('DOMContentLoaded', function() {
    
    document.querySelectorAll('.tpb-pdp-wrapper').forEach(function(wrapper) {
      
      const widgetEl = wrapper.querySelector('.tpb-payment-accordions');
      if (!widgetEl) return;
      
      const $  = function(sel) { return wrapper.querySelector(sel); };
      const $$ = function(sel) { return wrapper.querySelectorAll(sel); };

      // ── Mobile Smart Sticky Add to Cart：默认不固定；滚动超过原按钮位置后持续固定 ──
      // 点击加入购物车并打开侧边购物车后，自动隐藏 sticky 按钮，避免遮挡购物车里的“Finalizar compra”。
      (function initMobileSmartStickyCta() {
        const actions = wrapper.querySelector('.tpb-checkout-actions');
        if (!actions || actions.dataset.smartStickyReady === 'true') return;

        actions.dataset.smartStickyReady = 'true';

        const mobileMq = window.matchMedia('(max-width: 992px)');
        const sentinel = document.createElement('div');
        sentinel.className = 'tpb-sticky-cta-sentinel';
        actions.parentNode.insertBefore(sentinel, actions);

        let ticking = false;
        let stickySuspendedByCart = false;
        let cartSuspendStartedAt = 0;
        let lastStickyState = false;

        function setSticky(active) {
          const shouldShowSticky = active && !stickySuspendedByCart && !document.body.classList.contains('tpb-cart-drawer-open') && !isCartDrawerLikelyOpen();

          lastStickyState = active;
          actions.classList.toggle('is-sticky-cta', shouldShowSticky);
          actions.classList.toggle('is-sticky-suspended', active && !shouldShowSticky);
          document.body.classList.toggle('tpb-mobile-sticky-cta-active', shouldShowSticky);

          if (shouldShowSticky) {
            const h = actions.offsetHeight || 92;
            sentinel.style.height = h + 'px';
            document.body.style.setProperty('--tpb-sticky-cta-space', h + 'px');
          } else {
            sentinel.style.height = '0px';
            document.body.style.removeProperty('--tpb-sticky-cta-space');
          }
        }

        function isCartDrawerLikelyOpen() {
          const drawerSelectors = [
            'cart-drawer.active',
            'cart-drawer.is-active',
            'cart-drawer[open]',
            '#CartDrawer.active',
            '#CartDrawer.is-active',
            '#CartDrawer.is-open',
            '#CartDrawer[open]',
            '.cart-drawer.active',
            '.cart-drawer.is-active',
            '.cart-drawer.is-open',
            '.cart-drawer[open]',
            '.drawer.active',
            '.drawer.is-active',
            '.drawer.is-open',
            '.drawer[open]',
            '.drawer--cart.active',
            '.drawer--cart.is-active',
            '.drawer--cart.is-open',
            '.tactical-cart.active',
            '.tactical-cart.is-active',
            '.tactical-cart.is-open',
            '#tpb-cart-drawer.is-active',
            '.tpb-cart-drawer.active',
            '.tpb-cart-drawer.is-active',
            '.tpb-cart-drawer.is-open',
            '#tpb-cart-overlay.is-active',
            '.tpb-cart-overlay.is-active',
            '[data-cart-drawer].active',
            '[data-cart-drawer].is-active',
            '[data-cart-drawer].is-open',
            '[data-cart-drawer][open]'
          ];

          return drawerSelectors.some(function(selector) {
            return document.querySelector(selector);
          });
        }

        function suspendStickyForCart() {
          stickySuspendedByCart = true;
          cartSuspendStartedAt = Date.now();
          document.body.classList.add('tpb-cart-drawer-open');
          setSticky(false);
        }

        function releaseStickyAfterCartClose() {
          stickySuspendedByCart = false;
          document.body.classList.remove('tpb-cart-drawer-open');
          requestUpdate();
        }

        function updateSticky() {
          ticking = false;

          if (!mobileMq.matches) {
            setSticky(false);
            return;
          }

          if (stickySuspendedByCart || isCartDrawerLikelyOpen()) {
            setSticky(false);
            return;
          }

          const currentY = window.scrollY || window.pageYOffset || 0;
          const actionHeight = actions.offsetHeight || 92;
          const rect = sentinel.getBoundingClientRect();

          // 当页面滚动超过原按钮所在位置后，按钮固定在底部，并持续显示。
          // 往回滚到原位置之前，会恢复成页面中的普通按钮。
          const triggerLine = window.innerHeight - actionHeight - 8;
          const passedOriginalPosition = rect.top <= triggerLine;

          // 小幅滚动不触发，避免刚打开页面就固定。
          const passedInitialArea = currentY > 160;
          const shouldStick = passedInitialArea && passedOriginalPosition;

          setSticky(shouldStick);
        }

        function requestUpdate() {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(updateSticky);
        }

        // 提供给“加入购物车成功”逻辑调用。
        window.tpbSuspendStickyCtaForCart = suspendStickyForCart;
        window.tpbReleaseStickyCtaAfterCartClose = releaseStickyAfterCartClose;

        // 兼容自定义事件调用。
        window.addEventListener('tpb:cart-drawer-opened', suspendStickyForCart);
        window.addEventListener('tpb:cart-drawer-closed', releaseStickyAfterCartClose);

        // 点击常见关闭按钮/遮罩后，尝试恢复 sticky 状态。
        document.addEventListener('click', function(event) {
          if (!stickySuspendedByCart) return;

          const closeTarget = event.target.closest('[data-cart-close], [data-drawer-close], #tpb-close-cart, .cart-drawer__close, .drawer__close, .js-drawer-close, .tpb-cart-close, .modal__close-button, button[name="close"], .drawer__overlay, .cart-overlay, #tpb-cart-overlay, .tpb-cart-overlay');
          if (closeTarget) {
            setTimeout(function() {
              if (!isCartDrawerLikelyOpen()) releaseStickyAfterCartClose();
            }, 450);
          }
        }, true);

        // 监听主题侧边购物车 class/open 属性变化，关闭后恢复。
        const cartObserver = new MutationObserver(function() {
          if (!stickySuspendedByCart) return;
          // 给侧边购物车一点打开时间，避免刚点击加入购物车时被过早恢复。
          if (Date.now() - cartSuspendStartedAt < 900) return;
          if (!isCartDrawerLikelyOpen()) releaseStickyAfterCartClose();
        });
        cartObserver.observe(document.body, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['class', 'open', 'aria-hidden']
        });

        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate);
        if (mobileMq.addEventListener) mobileMq.addEventListener('change', requestUpdate);
        requestUpdate();
      })();

      const pixEnabled    = widgetEl.dataset.pixEnabled === 'true';
      const pixDiscount   = parseFloat(widgetEl.dataset.pixDiscount) / 100;
      const maxInst       = parseInt(widgetEl.dataset.maxInst) || 12;
      const freeInstCount = parseInt(widgetEl.dataset.freeInstBase) || 6;
      const shippingThreshold = parseInt(widgetEl.dataset.freeShippingThreshold) || 39900;
      const interestRate  = parseFloat(widgetEl.dataset.interest) / 100 || 0.0199;

      // ── 手风琴展开逻辑 ──
      const accHeaders = $$('.tpb-accordion-header');
      accHeaders.forEach(function(header) {
        header.addEventListener('click', function() {
          const item = this.parentElement;
          const isOpen = item.classList.contains('is-open');

          $$('.tpb-accordion-item').forEach(function(i) {
            i.classList.remove('is-open');
            const content = i.querySelector('.tpb-accordion-content');
            if(content) content.style.display = 'none';
          });
          if (!isOpen) {
            item.classList.add('is-open');
            const content = item.querySelector('.tpb-accordion-content');
            if(content) content.style.display = 'block';
          }
        });
      });

      // ── 核心分期计算渲染 ──
      var wasLocked = false;
      var unlockTimer = null;
      var cartIconHTML = '';
      const renderInstallments = function(priceCents) {
        if (priceCents <= 0) return;
        if (unlockTimer) { clearTimeout(unlockTimer); unlockTimer = null; }
        
        const isShippingUnlocked = priceCents >= shippingThreshold;
        const currentFreeInst = freeInstCount;
        
        const progLocked = wrapper.querySelector('#tpb-progress-box-locked');
        const progUnlocked = wrapper.querySelector('#tpb-progress-box-unlocked');
        const lockedIcon = progLocked ? progLocked.querySelector('.tpb-progress-icon') : null;
        if (!cartIconHTML && lockedIcon) cartIconHTML = lockedIcon.innerHTML;

        if (isShippingUnlocked) {
          if (wasLocked) {
            if (lockedIcon) {
              lockedIcon.innerHTML = '<svg viewBox="0 0 128 128" fill="none" style="transform:scale(1.6);transform-origin:center center"><path d="m64 22 8 5 10-2 4 9 9 4-2 10 6 8-6 8 2 10-9 4-4 9-10-2-8 5-8-5-10 2-4-9-9-4 2-10-6-8 6-8-2-10 9-4 4-9 10 2Z" fill="#b733ff"/><path d="m52 56 9 9 18-18" stroke="#fff" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/><path d="M103.903 23.775c.482 0 .724-.282.847-.726 1.248-6.732 1.17-6.893 8.183-8.223.482-.08.766-.361.766-.846 0-.484-.282-.766-.767-.846-6.973-1.41-6.772-1.573-8.182-8.225-.12-.443-.363-.725-.847-.725s-.725.282-.848.725c-1.41 6.652-1.17 6.812-8.182 8.225-.443.079-.767.36-.767.846 0 .483.324.765.766.846 7.016 1.41 6.935 1.491 8.183 8.223.12.444.363.726.847.726" fill="#fff"/><path d="M75.354 18.027c.266 0 .4-.156.467-.4.69-3.72.646-3.808 4.52-4.543.266-.044.423-.2.423-.467s-.156-.423-.424-.468c-3.851-.779-3.74-.868-4.519-4.543-.066-.244-.2-.4-.467-.4s-.401.156-.469.4c-.779 3.675-.646 3.763-4.519 4.543-.245.044-.424.2-.424.468 0 .267.179.423.423.467 3.875.78 3.83.824 4.52 4.542.067.245.2.401.468.401" fill="#b733ff"/><path d="M115.354 46.027c.266 0 .4-.156.467-.4.69-3.72.646-3.809 4.52-4.543.266-.045.423-.2.423-.467s-.156-.423-.424-.468c-3.851-.779-3.74-.868-4.519-4.543-.066-.244-.2-.4-.467-.4s-.401.156-.469.4c-.779 3.675-.646 3.763-4.519 4.543-.245.044-.424.2-.424.468 0 .267.179.423.423.467 3.875.78 3.83.824 4.52 4.542.067.245.2.401.468.401" fill="#b733ff"/></svg>';
            }
            $('#tpb-progress-fill').style.width = '100%';
            $('#tpb-progress-text').innerHTML = `<strong style="color:#b733ff;">Parabéns!</strong> Este produto já garante <strong style="color:#FFF;">frete grátis</strong>!`;
            $('#tpb-prog-curr').textContent = formatMoney(priceCents);
            $('#tpb-prog-targ').textContent = formatMoney(shippingThreshold);
            unlockTimer = setTimeout(function() {
              progLocked.style.display = 'none';
              if (progUnlocked) {
                progUnlocked.style.display = 'flex';
                $('#tpb-unlocked-curr').textContent = formatMoney(priceCents);
                $('#tpb-unlocked-targ').textContent = formatMoney(shippingThreshold);
              }
            }, 550);
          } else {
            if (progLocked) progLocked.style.display = 'none';
            if (progUnlocked) {
              progUnlocked.style.display = 'flex';
              $('#tpb-unlocked-curr').textContent = formatMoney(priceCents);
              $('#tpb-unlocked-targ').textContent = formatMoney(shippingThreshold);
            }
          }
        }
        wasLocked = !isShippingUnlocked;
        if (!isShippingUnlocked) {
          if (progUnlocked) progUnlocked.style.display = 'none';
          if (progLocked) {
             progLocked.style.display = 'flex';
             if (lockedIcon && cartIconHTML) lockedIcon.innerHTML = cartIconHTML;
             const faltam = shippingThreshold - priceCents;
             const percent = Math.min((priceCents / shippingThreshold) * 100, 100);
             
             $('#tpb-progress-text').innerHTML = `Com este produto, faltam <strong style="color:#b733ff;">${formatMoney(faltam)}</strong> para ganhar frete grátis.`;
             $('#tpb-prog-curr').textContent = formatMoney(priceCents);
             $('#tpb-prog-targ').textContent = formatMoney(shippingThreshold);
             $('#tpb-progress-fill').style.width = percent + '%';
          }
        }

        if (pixEnabled) {
          const pixPrice = Math.floor(priceCents * (1 - pixDiscount));
          const bannerPixSub = $('#tpb-banner-pix-sub');
          if (bannerPixSub) bannerPixSub.textContent = formatMoney(pixPrice) + ' à vista';
        }
        
        const bannerCcTitle = $('#tpb-banner-cc-title');
        if (bannerCcTitle) {
          const freeInstAmount = Math.floor(priceCents / freeInstCount);
          bannerCcTitle.textContent = freeInstCount + 'x de ' + formatMoney(freeInstAmount) + ' sem juros';
        }

        const bannerCcSub = $('#tpb-banner-cc-sub');
        if (bannerCcSub) {
          bannerCcSub.textContent = isShippingUnlocked
            ? 'Frete grátis neste produto'
            : 'Frete grátis a partir de ' + formatMoney(shippingThreshold);
        }

        if (pixEnabled) {
          const pixPrice = Math.floor(priceCents * (1 - pixDiscount));
          const pixSummary = $('#tpb-summary-pix');
          if (pixSummary) pixSummary.textContent = formatMoney(pixPrice);
          const pixSaveLine = $('#tpb-pix-save-line');
          if (pixSaveLine) {
            const savings = priceCents - pixPrice;
            pixSaveLine.textContent = 'Economize ' + formatMoney(savings) + ' pagando no PIX';
          }
        }

        const gridEl = $('#tpb-inst-grid');
        if (!gridEl) return;
        gridEl.innerHTML = '';

        const instRates = {2:0.0636,3:0.0552,4:0.0445,5:0.0463,6:0.0396,7:0.0402,8:0.0357,9:0.0375,10:0.0357,11:0.0327,12:0.0322};
        for (let i = 2; i <= maxInst; i++) {
          const isFree = i <= currentFreeInst;
          let monthly;
          if (isFree) {
            monthly = Math.floor(priceCents / i);
          } else {
            const rate = instRates[i] || interestRate;
            monthly = Math.floor(priceCents * (rate / (1 - Math.pow(1 + rate, -i))));
          }

          const card = document.createElement('div');
          card.className = 'tpb-grid-item';
          let badgeHtml = '';
          if (i === 3) badgeHtml = '<div class="tpb-grid-badge badge-juros" style="background-color: #b733ff;">MAIS ESCOLHIDA</div>';
          else if (i === currentFreeInst) badgeHtml = '<div class="tpb-grid-badge badge-juros">MELHOR OPÇÃO</div>';
          card.innerHTML = 
            badgeHtml + 
            '<div class="tpb-grid-top">' + i + 'x de ' + formatMoney(monthly) + '</div>' +
            '<div class="tpb-grid-btm">' + (isFree ? 'sem juros' : 'com juros') + '</div>';
          gridEl.appendChild(card);
        }
      };

      var initialPrice = parseInt(wrapper.dataset.initialPrice, 10) || 0;
      renderInstallments(initialPrice);

      // ── Variant 图片同步桥接 ──
      // Gallery 初始化发生在 Variant 初始化之后，因此先提供空函数占位。
      // 首次进入页面只同步价格/库存/按钮等状态，不自动跳到默认 Variant 图片。
      // 只有顾客主动点击尺寸/颜色后，才执行 Variant → Gallery 图片同步。
      var syncVariantImage = function() {};

      // ── 变体切换监听 ──
      var variantDataEl = document.getElementById('tpb-variant-data');
      if (variantDataEl) {
        const variants = JSON.parse(variantDataEl.textContent);
        const variantSubmitBtn = $('#tpb-submit-btn');
        const isDepositPreorder = wrapper.dataset.depositEnabled === 'true';
        const dualFulfillment = (!isDepositPreorder && window.TPBDualFulfillment)
          ? window.TPBDualFulfillment.create({ wrapper: wrapper, variants: variants })
          : null;

        // 定金预售使用独立的定金商品按钮。原商品可能因库存归零而显示为不可售，
        // 因此不使用原商品库存禁用规格，避免影响预售规格展示与选择。
        const resetPreorderOptionAvailability = function() {
          $$('.tpb-radio').forEach(function(radio) {
            radio.disabled = false;

            const swatch = radio.nextElementSibling;
            if (swatch && swatch.classList.contains('tpb-swatch')) {
              swatch.classList.remove('is-sold-out');
              swatch.setAttribute('aria-disabled', 'false');
              swatch.removeAttribute('title');
            }
          });
        };

        // 根据前置选项和真实库存，禁用当前不可购买的规格按钮。
        // 例如：颜色在前、尺寸在后时，尺寸会依据当前颜色的库存动态更新。
        const updateOptionAvailability = function(selected) {
          if (isDepositPreorder) {
            resetPreorderOptionAvailability();
            return;
          }

          if (dualFulfillment) {
            dualFulfillment.updateOptionAvailability(selected, $$('.tpb-radio'));
            return;
          }

          $$('.tpb-radio').forEach(function(radio) {
            const optionIndex = Number(radio.dataset.pos) - 1;
            const isAvailable = variants.some(function(variant) {
              if (!variant.available || variant.options[optionIndex] !== radio.value) return false;

              for (let i = 0; i < optionIndex; i++) {
                if (selected[i] && variant.options[i] !== selected[i]) return false;
              }

              return true;
            });

            radio.disabled = !isAvailable;

            const swatch = radio.nextElementSibling;
            if (swatch && swatch.classList.contains('tpb-swatch')) {
              swatch.classList.toggle('is-sold-out', !isAvailable);
              swatch.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
              swatch.setAttribute('title', isAvailable ? '' : 'Esgotado');
            }
          });
        };

        // 主按钮只同步当前变体状态，不改动原有 cart/add.js 和 FormData 加购逻辑。
        const updateSubmitButton = function(variant) {
          if (!variantSubmitBtn) return;

          const btnTextEl = variantSubmitBtn.querySelector('.tpb-btn-text') || variantSubmitBtn;
          const availableText = variantSubmitBtn.dataset.availableText || 'ADICIONAR AO CARRINHO';
          const soldOutText = variantSubmitBtn.dataset.soldOutText || 'PRODUTO ESGOTADO';

          if (variant.available) {
            variantSubmitBtn.disabled = false;
            btnTextEl.textContent = availableText;
          } else {
            variantSubmitBtn.disabled = true;
            btnTextEl.textContent = soldOutText;
          }
        };

        const updateVariant = function(shouldSyncVariantImage) {
          var selected = [];
          $$('.tpb-radio:checked').forEach(function(r) {
             selected[r.dataset.pos - 1] = r.value;
             const valLabel = $('#val-' + r.dataset.pos);
             if (valLabel) valLabel.textContent = r.value;
          });

          updateOptionAvailability(selected);

          const match = dualFulfillment
            ? dualFulfillment.resolve(selected)
            : variants.find(function(v) {
                return v.options.every(function(o, i) { return o === selected[i]; });
              });
          if (!match) return;

          if (dualFulfillment) {
            dualFulfillment.applyResolvedVariant(match);
            selected[dualFulfillment.originIndex] = match.options[dualFulfillment.originIndex];
          }

          const variantInput = $('#tpb-variant-id');
          const currentPriceEl = $('#tpb-price-current');
          const originalPriceEl = $('#tpb-price-original');
          const discountEl = $('#tpb-price-discount');

          if (variantInput) variantInput.value = match.id;
          if (currentPriceEl) currentPriceEl.textContent = formatMoney(match.price);

          if (originalPriceEl && discountEl) {
            if (match.compare_at_price && match.compare_at_price > match.price) {
              originalPriceEl.textContent = formatMoney(match.compare_at_price);
              originalPriceEl.style.display = '';

              const savings = match.compare_at_price - match.price;
              const percent = Math.round(savings * 100 / match.compare_at_price);
              discountEl.textContent = '-' + percent + '%';
              discountEl.style.display = '';
            } else {
              originalPriceEl.textContent = '';
              originalPriceEl.style.display = 'none';
              discountEl.textContent = '';
              discountEl.style.display = 'none';
            }
          }

          updateSubmitButton(match);
          renderInstallments(match.price);

          // 只有顾客主动切换可见规格时才同步 Variant 图片。
          // 页面首次初始化不触发，确保进入详情页时始终保留第 1 张主图。
          if (shouldSyncVariantImage === true) {
            syncVariantImage(match);
          }
        };

        $$('.tpb-swatch').forEach(function(swatch) {
          swatch.addEventListener('click', function() {
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                updateVariant(true);
              });
            });
          });
        });

        // 页面首次加载时立即标记售罄规格，并同步当前主按钮/价格/分期状态；
        // 不同步 Variant 图片，避免自动从第 1 张主图跳到默认 SKU 图片。
        updateVariant(false);
      }

      // ── 相册切换相关 (全局安全查询) ──
      const thumbnails = $$('.tpb-thumb-item');
      const mainImg = $('#tpb-main-img');
      const zoomImg = $('#tpb-zoom-img');
      const lightbox = $('#tpb-lightbox');
      const imgList = Array.from(thumbnails).map(function(t) { return t.getAttribute('data-src'); });
      const altList = Array.from(thumbnails).map(function(t) { return t.getAttribute('data-alt') || ''; });
      const srcsetList = Array.from(thumbnails).map(function(t) { return t.getAttribute('data-main-srcset') || ''; });
      var currentIndex = 0;
      var displayedImageIndex = 0;
      var galleryImageRequestId = 0;
      const galleryDots = $$('.tpb-gallery-dot-slot');
      const galleryDotsTrack = $('.tpb-gallery-dots-track');

      function updateGalleryDots(index) {
        if (!galleryDotsTrack || galleryDots.length < 2) return;
        galleryDots.forEach(function(dot, dotIndex) {
          dot.dataset.active = String(dotIndex === index);
          dot.dataset.distance = String(Math.abs(dotIndex - index));
        });
        const visibleCount = Math.min(5, galleryDots.length);
        const start = Math.max(0, Math.min(index - 2, galleryDots.length - visibleCount));
        galleryDotsTrack.style.transform = 'translateX(' + (-start * 16) + 'px)';
      }

      updateGalleryDots(displayedImageIndex);

      if (lightbox) { document.body.appendChild(lightbox); }

      function updateImg(idx) {
        if (!mainImg || !imgList.length || !Number.isInteger(idx)) return;
        const targetIndex = (idx + imgList.length) % imgList.length;
        if (currentIndex === targetIndex) return;
        currentIndex = targetIndex;
        const requestId = ++galleryImageRequestId;
        const src = imgList[targetIndex];
        const alt = altList[targetIndex] || mainImg.getAttribute('alt') || '';
        mainImg.style.opacity = '0.3';
        const tempImg = new Image();
        tempImg.onload = function() {
          // Only the latest requested image may update the gallery and dots.
          if (requestId !== galleryImageRequestId) return;
          if (srcsetList[targetIndex]) mainImg.srcset = srcsetList[targetIndex];
          else mainImg.removeAttribute('srcset');
          mainImg.src = src;
          mainImg.alt = alt;
          if (zoomImg) {
            zoomImg.src = src;
            zoomImg.alt = alt;
          }
          mainImg.style.opacity = '1';
          displayedImageIndex = targetIndex;
          thumbnails.forEach(function(t, i) {
            const active = i === targetIndex;
            t.classList.toggle('is-active', active);
            if (active) {
              t.setAttribute('aria-current', 'true');
              t.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
            } else {
              t.removeAttribute('aria-current');
            }
          });
          updateGalleryDots(targetIndex);
        };
        tempImg.onerror = function() {
          if (requestId !== galleryImageRequestId) return;
          currentIndex = displayedImageIndex;
          mainImg.style.opacity = '1';
        };
        tempImg.src = src;
      }

      // Shopify Variant JSON 中的关联图通常是原始 CDN URL，
      // 而缩略图 data-src 使用 1000x 版本。统一去掉尺寸后缀后再匹配。
      function getGalleryImageKey(url) {
        if (!url) return '';

        try {
          const parsed = new URL(url, window.location.origin);
          let pathname = decodeURIComponent(parsed.pathname || '').toLowerCase();

          pathname = pathname.replace(
            /_(?:pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*|\d*x\d+|x\d+)(?=(?:\.[^./]+)+$)/i,
            ''
          );

          return pathname;
        } catch (error) {
          return String(url)
            .split('?')[0]
            .toLowerCase()
            .replace(
              /_(?:pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*|\d*x\d+|x\d+)(?=(?:\.[^./]+)+$)/i,
              ''
            );
        }
      }

      function getVariantImageSrc(variant) {
        if (!variant) return '';

        if (variant.featured_image) {
          if (typeof variant.featured_image === 'string') return variant.featured_image;
          if (variant.featured_image.src) return variant.featured_image.src;
          if (variant.featured_image.url) return variant.featured_image.url;
        }

        if (variant.featured_media && variant.featured_media.preview_image) {
          return variant.featured_media.preview_image.src || variant.featured_media.preview_image.url || '';
        }

        return '';
      }

      syncVariantImage = function(variant) {
        if (!variant || !mainImg || !thumbnails.length) return;

        const variantImageSrc = getVariantImageSrc(variant);
        if (!variantImageSrc) return;

        const targetKey = getGalleryImageKey(variantImageSrc);
        if (!targetKey) return;

        const targetIndex = imgList.findIndex(function(src) {
          return getGalleryImageKey(src) === targetKey;
        });

        if (targetIndex >= 0) {
          updateImg(targetIndex);
        }
      };

      thumbnails.forEach(function(t, i) { t.addEventListener('click', function() { updateImg(i); }); });
      $('#tpb-prev-btn').onclick = function(e) { e.stopPropagation(); updateImg((currentIndex - 1 + imgList.length) % imgList.length); };
      $('#tpb-next-btn').onclick = function(e) { e.stopPropagation(); updateImg((currentIndex + 1) % imgList.length); };

      const lbPrev = document.getElementById('tpb-lb-prev');
      const lbNext = document.getElementById('tpb-lb-next');
      const lbClose = document.getElementById('tpb-lb-close');

      if(lbPrev) lbPrev.onclick = function(e) { e.stopPropagation(); updateImg((currentIndex - 1 + imgList.length) % imgList.length); };
      if(lbNext) lbNext.onclick = function(e) { e.stopPropagation(); updateImg((currentIndex + 1) % imgList.length); };

      const thumbScroll = $('#tpb-thumb-scroll');
      const btnUp = $('#tpb-thumb-up');
      const btnDown = $('#tpb-thumb-down');

      function updateThumbArrows() {
        if (!thumbScroll || !btnUp || !btnDown) return;
        const canScrollUp = thumbScroll.scrollTop > 5;
        const canScrollDown = Math.ceil(thumbScroll.scrollTop + thumbScroll.clientHeight) < thumbScroll.scrollHeight - 5;
        btnUp.classList.toggle('is-visible', canScrollUp); btnDown.classList.toggle('is-visible', canScrollDown);
      }

      if (thumbScroll) {
        setTimeout(updateThumbArrows, 300); thumbScroll.addEventListener('scroll', updateThumbArrows);
        window.addEventListener('resize', updateThumbArrows);
        btnUp && btnUp.addEventListener('click', function() { thumbScroll.scrollBy({ top: -180, behavior: 'smooth' }); });
        btnDown && btnDown.addEventListener('click', function() { thumbScroll.scrollBy({ top: 180, behavior: 'smooth' }); });
      }

      var tpbPreviousBodyOverflow = '';

      function openLightbox() {
        if (!lightbox || !mainImg) return;
        if (zoomImg) {
          zoomImg.src = imgList[displayedImageIndex] || mainImg.src;
          zoomImg.alt = altList[displayedImageIndex] || mainImg.alt || '';
        }
        tpbPreviousBodyOverflow = document.body.style.overflow || '';
        lightbox.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }

      function closeLightbox() {
        if (!lightbox || lightbox.style.display === 'none') return;
        lightbox.style.display = 'none';
        document.body.style.overflow = tpbPreviousBodyOverflow;
      }

      if (mainImg && lightbox) {
        mainImg.onclick = openLightbox;
      }

      if (lbClose) {
        lbClose.onclick = function(e) {
          if (e) e.stopPropagation();
          closeLightbox();
        };
      }

      if (lightbox) {
        lightbox.onclick = function(e) {
          if (e.target === lightbox) closeLightbox();
        };
      }

      document.addEventListener('keydown', function(e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && lightbox && lightbox.style.display === 'flex') {
          e.preventDefault();
          closeLightbox();
        }
      });

      // ── 居中模态弹窗逻辑 (Modals) ──
      const overlay = document.getElementById('tpb-modal-overlay');
      if (overlay) document.body.appendChild(overlay);
      
      document.querySelectorAll('.tpb-modal').forEach(function(modal) {
        document.body.appendChild(modal); 
      });

      const modalBtns = $$('[data-modal-target]');
      const closeBtns = document.querySelectorAll('.tpb-modal-close');
      let activeModal = null;

      function openModal(id) {
        const modal = document.getElementById(id);
        if(modal && overlay) {
          overlay.classList.add('is-active');
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden'; 
          activeModal = modal;
        }
      }

      function closeModal() {
        if(activeModal && overlay) {
          activeModal.classList.remove('is-open');
          overlay.classList.remove('is-active');
          document.body.style.overflow = 'auto'; 
          activeModal = null;
        }
      }

      modalBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          openModal(this.getAttribute('data-modal-target'));
        });
      });

      closeBtns.forEach(function(btn) {
        btn.addEventListener('click', closeModal);
      });

      if(overlay) {
        overlay.addEventListener('click', closeModal);
      }

      // ── 表单提交 (终极战术版：完整抓取表单数据 + 物理阻断主题干扰) ──
      const submitBtn = document.getElementById('tpb-submit-btn');
      const tacticalForm = document.getElementById('tpb-tactical-form');

      if (submitBtn && tacticalForm) {
        submitBtn.addEventListener('click', function(e) {
          e.preventDefault();
          
          const btnTextEl = this.querySelector('.tpb-btn-text') || this;
          const originalText = btnTextEl.innerHTML;
          
          this.disabled = true;
          btnTextEl.innerHTML = 'ADICIONANDO... ⟳'; 

          const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
          
          const formData = new FormData(tacticalForm);

          fetch(rootUrl + 'cart/add.js', { 
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData 
          })
          .then(response => {
            if (!response.ok) {
              return response.json().then(err => { throw err; });
            }
            return response.json(); 
          })
          .then(data => {
            this.disabled = false;
            btnTextEl.innerHTML = originalText;

            // 加入购物车成功后先隐藏移动端 sticky CTA，避免遮挡侧边购物车底部按钮。
            if (window.tpbSuspendStickyCtaForCart) {
              window.tpbSuspendStickyCtaForCart();
            }
            window.dispatchEvent(new CustomEvent('tpb:cart-drawer-opened'));
            
            if (window.openTacticalCart) {
              window.openTacticalCart(); 
            } else {
              window.location.href = rootUrl + 'cart';
            }
          })
          .catch(error => {
            console.error('❌ Erro detalhado da Shopify:', error);
            this.disabled = false;
            const errorMsg = error.description ? 'ERRO: ' + error.description : 'ERRO / ESGOTADO ✕';
            btnTextEl.innerHTML = errorMsg; 
            setTimeout(() => { btnTextEl.innerHTML = originalText; }, 3000); 
          });
        });
      }


      // ── 定金预售商品加入购物车：与原商品表单完全分离 ──
      const depositSubmitBtn = wrapper.querySelector('#tpb-deposit-submit-btn');

      if (depositSubmitBtn && !depositSubmitBtn.disabled) {
        depositSubmitBtn.addEventListener('click', function(e) {
          e.preventDefault();

          const variantId = this.getAttribute('data-deposit-variant-id');
          if (!variantId) return;

          const btnTextEl = this.querySelector('.tpb-btn-text') || this;
          const originalText = btnTextEl.innerHTML;

          this.disabled = true;
          btnTextEl.innerHTML = 'ADICIONANDO... ⟳';

          const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
            ? window.Shopify.routes.root
            : '/';

          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');

          fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          })
          .then(function(response) {
            if (!response.ok) {
              return response.json().then(function(err) { throw err; });
            }
            return response.json();
          })
          .then(function() {
            depositSubmitBtn.disabled = false;
            btnTextEl.innerHTML = originalText;

            if (window.tpbSuspendStickyCtaForCart) {
              window.tpbSuspendStickyCtaForCart();
            }
            window.dispatchEvent(new CustomEvent('tpb:cart-drawer-opened'));

            if (window.openTacticalCart) {
              window.openTacticalCart();
            } else {
              window.location.href = rootUrl + 'cart';
            }
          })
          .catch(function(error) {
            console.error('❌ Erro ao adicionar a reserva:', error);
            depositSubmitBtn.disabled = false;
            btnTextEl.innerHTML = error && error.description
              ? 'ERRO: ' + error.description
              : 'ERRO / ESGOTADO ✕';

            setTimeout(function() {
              btnTextEl.innerHTML = originalText;
            }, 3000);
          });
        });
      }


    }); 
  });
